/**
 * Application configuration derived from environment variables.
 *
 * VITE_TRACKING_DOMAIN — the neutral domain used for client-facing tracking URLs
 * (click, postback, campaign slugs, CDN assets).  Must be set explicitly via
 * environment variable — there is no hardcoded default so the routing domain
 * can be rotated instantly by changing env vars and redeploying.
 */

/** Neutral routing domain (no protocol, no trailing slash). */
export const TRACKING_DOMAIN: string =
  import.meta.env.VITE_TRACKING_DOMAIN ||
  (() => { throw new Error('VITE_TRACKING_DOMAIN is required') })()

/** Help / documentation URL shown in the sidebar. */
export const HELP_URL: string =
  import.meta.env.VITE_HELP_URL || 'https://docs.getghostflow.io'
